import PropTypes from 'prop-types';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

const AutoInvoice = ({ auto }) => {
    const trl = useTrls();

    if (auto) {
        return null;
    }
    return <Label type="auto-payment">{trl('admin.Invoices.InvoicesTable.Invoice.notAutoPayment')}</Label>;
};

AutoInvoice.propTypes = {
    auto: PropTypes.bool,
};

export default AutoInvoice;
